// @flow
import { ACTIONS } from '../constants';
import setNotificationSettingsAllPush from '../api/setNotificationSettingsAllPush';

const setNotificationSettingsAllPushAction = (enabled: boolean) => (
    dispatch: Function
) => {
    setNotificationSettingsAllPush(enabled);

    dispatch({
        type: ACTIONS.NOTIFICATION_SETTINGS_SET_ALL_PUSH,
        enabled
    });
};

export default setNotificationSettingsAllPushAction;



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/state/setNotificationSettingsAllPush.js